// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyChC0x63GBnBjfMDSgRCeThHIDNpE8bkLM",
    authDomain: "hiring-uat-d0d0a.firebaseapp.com",
    databaseURL: "https://hiring-uat-d0d0a.firebaseio.com",
    projectId: "hiring-uat-d0d0a",
    storageBucket: "hiring-uat-d0d0a.appspot.com",
    messagingSenderId: "700264188304",
    appId: "1:700264188304:web:ba04a8653cb89e2c93cb15",
    measurementId: "G-V8NP13SZXK"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
